import { GetterTree } from 'vuex'
import { MessageTypesState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<MessageTypesState, RootState> = {
    messageTypes:state => state.messageTypes,
};